import { render, staticRenderFns } from "./QueueList.vue?vue&type=template&id=71b2c082&scoped=true"
import script from "./QueueList.vue?vue&type=script&lang=js"
export * from "./QueueList.vue?vue&type=script&lang=js"
import style0 from "./QueueList.vue?vue&type=style&index=0&id=71b2c082&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71b2c082",
  null
  
)

export default component.exports